import React from 'react';
import { connect } from 'react-redux';
import Valg, { DisplayValue } from '../../Shared/Scripts/Models/Valg';
import VeilederStegComponent, { VeilederStegDefaultProps, VeilederStegBaseProps } from '../../Shared/Scripts/Components/VeilederStegComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import ForelopigUttalelseSkjemaSideDto from '../Models/ForelopigUttalelseSkjemaSideDto';
import { ForelopigUttalelseSkjemaSideAppState } from '../Store';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import { StegVisning } from '../../Shared/Scripts/Store/StegVisning/Types';
import SelectOptionDisplay from '../../Shared/Scripts/Components/SelectOptionComponent';

type Steg3ComponentOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    ledetekst: JSX.Element | null,
    onChange: any,
    value?: Valg<string>,
}

type Steg3DisplayProps = Steg3ComponentOwnProps & MapStateToProps & MapDispatchToProps;

function Steg3ComponentVisning(props: Steg3DisplayProps): JSX.Element {

    function hentLandListe(): DisplayValue[] {
        //Disse land/verdensdel verdiene er også hardkodet i ForelopigUttalelseServices.cs
        let land: DisplayValue[] = [];

        if(window.location.href.toLowerCase().indexOf('/en-us/') > 0) {
            //engelske  land-navn
            land.push({id: "USA", displayValue: "USA"});
            land.push({id: "Canada", displayValue: "Canada"});
            land.push({id: "Asia", displayValue: "Asia"});
            land.push({id: "Europa", displayValue: "Europe"});
            land.push({id: "SorOgMellomAmerika", displayValue: "South and Central America"});
            land.push({id: "Afrika", displayValue: "Africa"});
            land.push({id: "Oseania", displayValue: "Oceania"});
        } else {
            //norske land-navn
            land.push({id: "USA", displayValue: "USA"});
            land.push({id: "Canada", displayValue: "Canada"});
            land.push({id: "Asia", displayValue: "Asia"});
            land.push({id: "Europa", displayValue: "Europa"});
            land.push({id: "SorOgMellomAmerika", displayValue: "Sør- og Mellom Amerika"});
            land.push({id: "Afrika", displayValue: "Afrika"});
            land.push({id: "Oseania", displayValue: "Oseania"});
        };

        return land;
    }

    function onSelectHandling(valg: Valg<string>) : void {
        props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:true});

        props.onChange(valg);
        
        let avhukingsboks: HTMLInputElement | null = document.getElementById("checkbox-tilleggsstipend") as HTMLInputElement | null;
        if(avhukingsboks !== null)
            avhukingsboks.checked = false;
    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={props.forklaring}
            canCollapse={props.value != null}
            displayElement={<div className="c-veileder__valgt-item">
                <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
            </div>}
            inputArea={
                <div className="c-veileder__inputomrade">
                    <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken">
                        <SelectOptionDisplay
                            htmlId={props.sporsmalId+'-uni-select'}
                            ledetekst={props.ledetekst}
                            options={hentLandListe()}
                            onSelectChange={(nyttValg: Valg<string>): void => {
                                onSelectHandling(nyttValg);
                            }}
                            showSearch={false}
                            value={props.value}
                        />
                    </div>
                </div>
            }
            sporsmalId={props.sporsmalId}
        />
    )
}

interface MapStateToProps {
    epiContext: EpiContext<ForelopigUttalelseSkjemaSideDto>;
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: ForelopigUttalelseSkjemaSideAppState, ownProps: Steg3ComponentOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
            epiContext: state.epiContext,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(Steg3ComponentVisning);